import { useInterval } from "@prismicio/editor-support/React"
import { useState } from "react"

import type { ABMLandingPagesApiClient } from "../../app/services/aiLandingPage"
import type { ImportCompaniesState } from "../../app/services/aiLandingPage/ImportCompaniesState"

export function useImportCompanies(args: {
  apiClient: ABMLandingPagesApiClient
}) {
  const { apiClient } = args
  const [taskState, setTaskState] = useState<ImportCompaniesState>({
    status: "NOT_STARTED",
  })
  const [executionArn, setExecutionArn] = useState<string>()

  const action = async (args: { csv: string }) => {
    const { csv } = args

    setTaskState({ status: "RUNNING" })

    try {
      const executionArn = await apiClient.startImportCompanies({
        csv,
      })
      setExecutionArn(executionArn)
    } catch (err) {
      setTaskState({ status: "FAILED" })
      setExecutionArn(undefined)
    }
  }

  const checkStatus = async () => {
    if (!executionArn) return

    const updatedTaskState = await apiClient.checkImportCompaniesStatus({
      executionArn,
    })

    setTaskState(updatedTaskState)

    if (updatedTaskState.status === "RUNNING") return

    setExecutionArn(undefined)
  }

  const delay = executionArn && taskState.status === "RUNNING" ? 5000 : null

  useInterval(checkStatus, delay)

  return {
    action,
    disabled: taskState.status === "RUNNING",
    taskState,
  }
}
